export class RadioItem {
	key: string | number;
	value: string;
	translation?: string;
}
